export const TAX_RATE = 0.06
export const ASSEMBLY_FEE = 20
